import { StyledSelectOption } from "gatsby-interface"
import { useNetlifyAccountsListQuery } from "@modules/cdn/netlify/queries.generated"

export function useNetlifyAccountOptions(
  siteId: string
): readonly [StyledSelectOption[], { loading: boolean }] {
  const { data, loading } = useNetlifyAccountsListQuery({
    variables: {
      siteId,
    },
    fetchPolicy: `cache-and-network`,
  })

  const accounts = data?.netlifyAccountsForGatsbySiteId ?? []

  const options = [{ label: "", value: "" }].concat(
    accounts.map(({ slug }) => ({
      label: slug,
      value: slug,
    }))
  )

  return [options, { loading }]
}
